<template lang="pug">
.central-settings.col-sm-10.col-md-10
    .row-col
        .padding
            .alert.info 
                i.material-icons.md-24.m-r-sm &#xe88f;
                | By default all {{ trans('general.outlets').toLowerCase() }} will use the default settings.
                | To create specific {{ trans('general.outlet').toLowerCase() }} settings,
                | create a new settings set and assign {{ trans('general.outlets').toLowerCase() }} accordingly.
            .box
                v-server-table(
                    ref="datatable",
                    :url="url",
                    name="CENTRAL_SETTING_SETS",
                    :columns="columns",
                    :options="options"
                )

        set-form(ref="settingSetForm")
        set-update-form(ref="setValuesForm")
</template>

<script>
import { mapActions } from 'vuex';
import Auth from '@js/plugins/auth';
import setForm from './central-setting-set-form.vue';
import setUpdateForm from './central-setting-set-update.vue';
import event from './central-setting-event';

export default {
    components: {
        setForm,
        setUpdateForm,
    },

    data() {
        let canManageSettings = Auth.hasPermissionTo(
            'franchise_manage_settings',
        );

        let actionButtons = [
            {
                title: 'New Settings Set',
                action: () => {
                    this.showSettingSetForm();
                },
            },
        ];

        if (!canManageSettings) {
            actionButtons = [];
        }

        return {
            columns: ['name', 'description', 'outlets'],
            options: {
                checkbox: canManageSettings,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.setting.central_settings.set.delete',
                    ),
                    delete_title: 'Delete Settings Set',
                },
                actionButtons: actionButtons,
                checkboxDisableCallback: row => row.default,
                rowClickCallback: row =>
                    this.$refs.setValuesForm.$emit('show', row.id),
                rowClassCallback: row => 'pointer',
                templates: {
                    outlets(h, row) {
                        return require('./outlet-column.jsx')(h, row);
                    },
                },
                sortable: ['name', 'description'],
            },
        };
    },

    computed: {
        url() {
            return Laroute.route(
                'franchise.setting.central_settings.set.index',
            );
        },
    },

    mounted() {
        this.getOutletList({ query: null, limit: null });
        this.getAssignedOutletList();

        event.$on('set-updated', () => {
            this.getAssignedOutletList();
            this.$refs.datatable.getData();
        });

        event.$on('set-created', () => {
            this.$refs.datatable.getData();
        });
    },

    methods: {
        ...mapActions('outlet', ['getOutletList']),
        ...mapActions('centralSettings', [
            'setSettingSet',
            'getAssignedOutletList',
        ]),

        showSettingSetForm() {
            this.$refs.settingSetForm.$emit('show');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/central-settings/central-settings.vue